/*
 * @Description:
 * @Date: 2024-03-18 18:15:22
 */
import {
  XrkMessage,
  XrkTableProps,
  XrkTableRef,
  createDialog,
  BaseTextContent
} from 'xrk-components';
import _ConfigProductVue from './config-product.vue';
import { XrkTable } from 'xrk-components';
import { Product } from '../../data-source/types';
import { dealTableColumnstextLineClamp } from '../../tools';
import { ref } from 'vue';
import { createDrugFormDialog } from '../drug-form';
import { createDeviceFormDialog } from '../device-form';
import { getConfigProductList } from '../../data-source/api';
import {
  PRESCRIPTION_TYPE,
  PRESCRIPTION_TYPE_MAP,
  PRODUCT_DEVICE,
  PRODUCT_TYPE,
  PRODUCT_TYPE_MAP
} from '../../config';
import { useZsStore } from '../../store';

type ColumnsType = Product['row'];
type SearchType = Product['search'];
type TableConfig = XrkTableProps<SearchType, ColumnsType>;

export const ConfigProductVue = _ConfigProductVue;

const previewProduct = (row: ColumnsType) => {
  const _row = { ...row };
  Object.keys(_row).forEach(key => {
    if (key !== 'fileUrl' && ['', null, void 0].includes(_row[key])) {
      _row[key] = '-';
    }
  });
  if (_row['type'] === PRODUCT_DEVICE) {
    createDeviceFormDialog(_row, 'preview');
  } else {
    createDrugFormDialog(_row, 'preview');
  }
};

export const ProductTableColumns: TableConfig['tableConfig']['tableColumns'] = [
  {
    minWidth: 100,
    prop: 'type',
    label: '产品类型',
    formatter: ({ cellValue }) => PRODUCT_TYPE_MAP[cellValue as any]
  },
  {
    minWidth: 100,
    prop: 'name',
    label: '产品名称',
    render: ({ cellValue, row }) => (
      <div
        style={{ color: 'var(--xrk-color-primary2)', cursor: 'pointer' }}
        onClick={() => {
          previewProduct(row);
        }}
      >
        {cellValue}
      </div>
    )
  },
  {
    minWidth: 100,
    prop: 'isOtc',
    label: '是否处方药',
    formatter: ({ cellValue, row }) =>
      cellValue === null || row['type'] === PRODUCT_DEVICE
        ? '—'
        : PRESCRIPTION_TYPE_MAP[+(cellValue as any)]
  },
  { minWidth: 200, prop: 'approvalNumber', label: '药品批准文号/注册证编号' }
];

export const chooseProduct = (choosedDataIds: Set<number>) => {
  const XrkTableRef = ref<XrkTableRef<SearchType, ColumnsType>>();

  const searchConfig: TableConfig['searchConfig'] = {
    searchColumns: [
      {
        type: 'select',
        prop: 'type',
        label: '产品类型',
        config: {
          options: PRODUCT_TYPE,
          clearable: true
        }
      },
      {
        type: 'input',
        prop: 'name',
        label: '产品名称',
        style: { width: '200px' },
        config: {
          maxlength: 20,
          clearable: true
        }
      },
      {
        type: 'select',
        prop: 'isOtc',
        label: '是否处方药',
        config: {
          options: PRESCRIPTION_TYPE,
          clearable: true
        }
      }
    ]
  };
  const tableConfig: TableConfig['tableConfig'] = {
    baseConfig: { rowKey: 'productId' },
    tableColumns: dealTableColumnstextLineClamp<
      TableConfig['tableConfig']['tableColumns']
    >([
      {
        type: '_selection',
        prop: 'productId',
        width: 60,
        selectionDisabled: row => choosedDataIds.has(row.productId),
        renderHeaderSelectionLabel: () => <> </>
      },
      { type: 'index', label: '序号', width: 80 },
      ...ProductTableColumns
    ])
  };
  return new Promise<Array<ColumnsType>>(resolve => {
    createDialog({
      title: '选择产品',
      width: 900,
      contentRender: () => (
        <BaseTextContent>
          <XrkTable
            ref={XrkTableRef}
            searchConfig={searchConfig}
            tableConfig={tableConfig}
            paginationConfig={{ paginationPageSize: 15 }}
            getListAjax={async params => {
              const res = await getConfigProductList({
                enterpriseId: useZsStore().enterpriseId.value,
                ...params,
                excludeIds: Array.from(choosedDataIds)
              });
              res.data?.list?.forEach((item: any) => {
                item['productId'] = item['id'];
              });
              return res;
            }}
          ></XrkTable>
        </BaseTextContent>
      ),
      confirmBtnConfig: {
        show: true,
        type: 'primary',
        content: '确定'
      },
      cancelBtnConfig: { show: true, type: 'default', content: '取消' },
      beforeConfirm: async done => {
        const res = XrkTableRef.value?.getSelectionRows();
        if (res.length === 0) {
          XrkMessage.error('请至少勾选一种产品');
          return Promise.reject();
        }
        resolve(XrkTableRef.value?.getSelectionRows());
        done();
      }
    });
  });
};
